import { segmentTrackAction } from 'lib/segment'
import { EVENT } from 'lib/segment/const'

export const segmentCategoryLayoutToggleEvent = ({
  ref_id,
  view_type,
  ref_type,
}) => {
  const data = {
    ref_id: Number(ref_id),
    ref_type,
    view_type,
  }
  segmentTrackAction(EVENT.categoryLayoutToggleEvent, data)
}

export const segmentProductVideoViewedEvent = ({
  ref_id,
  ref_type,
  id_product,
  id_site_category,
  site_category_name,
}) => {
  const data = {
    ref_id: Number(ref_id),
    ref_type,
    id_product,
    site_category_name,
    id_site_category,
  }
  segmentTrackAction(EVENT.productVideoViewedEvent, data)
}
